import { ContentActionTypes, ContentActions } from './content.actions';
import { ContentState, initialContentState } from './content.state';

import { ContentPage, ContentSection } from '@nrwl/rx-service-content-editor';
import { SelectionModel } from '@angular/cdk/collections';

export function contentReducer(
  state: any = initialContentState,
  action: ContentActions | any,
): ContentState {
  switch (action.type) {
    case ContentActionTypes.CreateCategorySuccess:
      return {
        ...state,
        categories: [action.payload, ...state.categories], // Insert category at the top of the list
        error: '',
      };

    case ContentActionTypes.EmptyNewContentSection: {
      const contentSection = new ContentSection();
      return {
        ...state,
        selectedCategoryItem: contentSection,
        categoryItemPages: [],
        selectedPage: null,
      };
    }

    case ContentActionTypes.SkipUpdateContentSectionStore:
      return {
        ...state,
        skipUpdateContentSection: true,
      };

    case ContentActionTypes.AllowUpdateContentSectionStore:
      return {
        ...state,
        skipUpdateContentSection: false,
      };

    case ContentActionTypes.LoadCategoryItem:
      return {
        ...state,
        selectedCategoryItem: null,
        categoryItemPages: [],
      };

    case ContentActionTypes.LoadCategories:
      return {
        ...state,
      };

    case ContentActionTypes.LoadCategoriesSuccess: {
      const pagedCategories = action.payload.results;

      return {
        ...state,
        categories: pagedCategories,
        error: '',
      };
    }

    case ContentActionTypes.LoadCategoryItemSuccess: {
      const section = action.payload.section;
      const pages = action.payload.pages;
      let selectedPage: any = null;

      // Concatinate section and pages
      section.pages = pages;

      let updatedCategoryItems = [];

      updatedCategoryItems =
        state.categoryItems.length > 0
          ? state.categoryItems.map((item) =>
              action.payload.section.id === item.id ? section : item,
            )
          : [section];

      selectedPage =
        action.payload.pages.results.length > 0 ? action.payload.pages.results[0] : null;

      if (selectedPage && selectedPage.content && !selectedPage.content.pageFeId) {
        selectedPage.content.pageFeId =
          'uid' + Math.random().toString(36).substring(2) + Date.now();
      }

      // Merge Pages and CategoryItems?
      return {
        ...state,
        categoryItems: [...updatedCategoryItems],
        selectedCategoryItemId: section.id,
        selectedCategoryItem: section,
        sectionPages: pages.results,
        showPreview: !!action.payload.showPreview,
        selectedPage: selectedPage,
      };
    }
    case ContentActionTypes.LoadCategoryItems:
      return {
        ...state,
      };

    case ContentActionTypes.LoadCategoryItemsSuccess: {
      // Update existing items if any
      action.payload.forEach((incoming) => {
        const match = state.categoryItems.find((old) => old.id === incoming.id);
        if (match) {
          incoming = Object.assign(match, incoming);
        }
      });

      // Get existing items from state
      const stateItems = state.categoryItems.filter((existing: any) => {
        return !action.payload.some((incoming: any) => {
          return existing.id === incoming.id;
        });
      });

      // Merge existing and recieved items
      const merged = [...stateItems, ...action.payload];

      // Remove categories from busy list
      const reducedCategories = new SelectionModel<number>(true, state.busyCategories.selected);

      if (merged.length === 0) {
        reducedCategories.clear();
      } else {
        // Get categories to deselect
        const mergedIds = merged.map((data) => data.section_group);
        reducedCategories.deselect(...mergedIds);

        // Deselect missing categories (ex. Section Groups without Sections)
        reducedCategories.deselect(
          ...reducedCategories.selected.filter((id) => mergedIds.indexOf(id) === -1),
        );
      }

      // Add items to categories
      const updatedCategries = state.categories.map((categ) => {
        categ.sections = merged
          .filter((item) => item.section_group === categ.id)
          .map((item) => new ContentSection(item));
        return categ;
      });

      return {
        ...state,
        categories: [...updatedCategries],
        categoryItems: [...merged],
        error: '',
      };
    }

    case ContentActionTypes.UpdateMediaDataBuffer: {
      const buffer = { ...state.mediaDataObj };

      buffer[action.payload.widgetId] = action.payload.buffer.map((item) => {
        return {
          back_end: item.id,
          front_end: state.selectedPage.content.pageFeId,
          type: item.type,
        };
      });

      return {
        ...state,
        mediaDataObj: buffer,
        error: '',
      };
    }

    case ContentActionTypes.LoadCategoryItemPagesSuccess: {
      return {
        ...state,
        categoryItemPages: action.payload,
        error: '',
      };
    }

    case ContentActionTypes.SetShowPreview: {
      return {
        ...state,
        showPreview: action.payload,
      };
    }

    case ContentActionTypes.UpdateContentSectionGroup: {
      return {
        ...state,
      };
    }
    case ContentActionTypes.UpdateContentSectionGroupSuccess: {
      return {
        ...state,
      };
    }
    case ContentActionTypes.UpdateContentSection:
      return {
        ...state,
      };
    case ContentActionTypes.UpdateContentSectionSuccess: {
      const updatedContentSections = state.categoryItems.map((item) =>
        action.payload.id === item.id ? action.payload : item,
      );

      return {
        ...state,
        categoryItems: updatedContentSections,
      };
    }
    case ContentActionTypes.UpdateContentPage:
      return {
        ...state,
      };
    case ContentActionTypes.UpdateContentPageSuccess: {
      const updatedPages = state.sectionPages.map((item) => {
        return action.payload.id === item.id ? action.payload : item;
      });

      const page = action.payload as ContentPage;
      // page.content = JSON.parse(page.content);

      if (page?.content && !page.content.pageFeId) {
        page.content.pageFeId = 'uid' + Math.random().toString(36).substring(2) + Date.now();
      }

      return {
        ...state,
        selectedPage: page,
        sectionPages: [...updatedPages],
      };
    }
    case ContentActionTypes.CreateCategoryItemSuccess: {
      const searchIdx = state.search.findIndex((model) => model.type === action.payload.getType());
      const tempSelectedCategoryItem = action.loadInEditor
        ? action.payload
        : state.selectedCategoryItem;
      const tempState = { ...state, error: '', selectedCategoryItem: tempSelectedCategoryItem };

      if (searchIdx !== -1) {
        tempState.search[searchIdx].result.templates = [
          ...tempState.search[searchIdx].result.templates,
          action.payload,
        ];
      } else {
        tempState.categoryItems = [...state.categoryItems, action.payload];
      }

      return tempState;
    }

    case ContentActionTypes.CreateCategoryItemPageSuccess: {
      const contentPages = [...state.sectionPages];
      contentPages.unshift(action.payload);

      const page = action.payload;
      if (page?.content && !page.content.pageFeId) {
        page.content.pageFeId = 'uid' + Math.random().toString(36).substring(2) + Date.now();
      }

      return {
        ...state,
        selectedPage: page,
        sectionPages: contentPages,
        error: '',
      };
    }

    case ContentActionTypes.ArchiveCategory:
      return {
        ...state,
      };
    case ContentActionTypes.ArchiveCategorySuccess: {
      const archivedCategories = state.categories.map((item) =>
        action.payload.id === item.id ? action.payload : item,
      );
      return {
        ...state,
        categories: archivedCategories,
      };
    }
    case ContentActionTypes.ArchiveCategoryItem:
      return {
        ...state,
      };
    case ContentActionTypes.ArchiveCategoryItemSuccess: {
      const archivedCategoryItems = state.categoryItems.map((item) =>
        action.payload.id === item.id ? action.payload : item,
      );
      return {
        ...state,
        categoryItems: archivedCategoryItems,
      };
    }
    case ContentActionTypes.RestoreCategory:
      return {
        ...state,
      };
    case ContentActionTypes.RestoreCategorySuccess: {
      const restoredCategories = state.categories.map((item) =>
        action.payload.id === item.id ? action.payload : item,
      );
      return {
        ...state,
        categories: restoredCategories,
      };
    }
    case ContentActionTypes.RestoreCategoryItemSuccess: {
      const restoredCategoryItems = state.categoryItems.map((item) =>
        action.payload.id === item.id ? action.payload : item,
      );
      return {
        ...state,
        categoryItems: restoredCategoryItems,
      };
    }
    case ContentActionTypes.LeftViewMode:
      return {
        ...state,
        leftViewMode: action.payload,
      };

    case ContentActionTypes.ResetSearch:
      return {
        ...state,
        search: state.search.filter((item) => item.type !== action.payload),
      };

    case ContentActionTypes.ToggleSearchResult: {
      const idx = state.search.findIndex((item) => item.type === action.payload.type);
      const data =
        idx !== -1
          ? [...state.search, action.payload]
          : state.search.filter((item) => item.type === action.payload.type);
      return {
        ...state,
        search: data,
      };
    }
    case ContentActionTypes.SetSearchResult: {
      const searchValue: any = [...state.search];

      const searchModel: any = action.payload;

      let categoriesIds: any = state.categories.map((item) => item.id);
      searchModel.result.categories = [];

      const selectedCategories: any = [...state.selectedCategories.selected];
      const deletedTemplates: any = [];
      searchModel.result.templates.forEach((item: any, idx: any) => {
        if (categoriesIds.includes(item.section_group)) {
          const category = state.categories.find((category) => category.id === item.section_group);
          if (!category.is_deleted) {
            searchModel.selectedTemplates.selected.push({
              category: item.section_group,
              searchType: action.payload.type,
            });
            searchModel.result.categories.push(category);
            categoriesIds = categoriesIds.filter((idx) => idx !== item.section_group);
          } else {
            deletedTemplates.push(item.id);
          }
        }
      });

      // exclude templates from deleted categories
      searchModel.result.templates = searchModel.result.templates.filter(
        (item: any) => !deletedTemplates.includes(item.id),
      );

      if (searchValue.length) {
        const idx = searchValue.findIndex((item) => item.type === action.payload.type);
        if (idx !== -1) {
          searchValue[idx] = action.payload;
        } else {
          searchValue.push(action.payload);
        }
      } else {
        searchValue.push(action.payload);
      }
      return {
        ...state,
        selectedCategories: new SelectionModel<any>(true, [...selectedCategories]),
        search: searchValue,
      };
    }
    case ContentActionTypes.RightViewMode:
      return {
        ...state,
        rightViewMode: action.payload,
      };

    case ContentActionTypes.SelectCategoriesSuccess: {
      // Currently selected items
      const selected = [...state.selectedCategories.selected];

      // Select new and Deselect duplicates
      action.payload?.forEach((item: any) => {
        const matchIndex = selected.findIndex(
          (entry) => entry.category === item.category && entry.searchType === item.searchType,
        );
        if (matchIndex === -1) {
          selected.push(item);
        } else {
          selected.splice(matchIndex, 1);
        }
      });

      return {
        ...state,
        selectedCategories: new SelectionModel<any>(true, [...selected]),
        error: '',
      };
    }
    case ContentActionTypes.SelectPage: {
      const page = action.payload;

      if (typeof page?.content === 'string') {
        page.content = JSON.parse(page.content);
      }

      if (page?.content && !page.content.pageFeId) {
        page.content.pageFeId = 'uid' + Math.random().toString(36).substring(2) + Date.now();
      }

      return {
        ...state,
        selectedPage: page,
      };
    }

    case ContentActionTypes.SelectCategoryItemById:
      return {
        ...state,
        selectedCategoryItemId: action.payload,
        error: '',
      };

    case ContentActionTypes.ArchiveSectionPage:
      return {
        ...state,
      };
    case ContentActionTypes.ArchiveSectionPageSuccess: {
      const contentSectionPages = state.sectionPages.filter(
        (item) => action.payload.id !== item.id,
      );

      const page = contentSectionPages.length > 0 ? contentSectionPages[0] : null;
      if (page?.content && !page.content.pageFeId) {
        page.content.pageFeId = 'uid' + Math.random().toString(36).substring(2) + Date.now();
      }

      return {
        ...state,
        sectionPages: contentSectionPages,
        selectedPage: page,
      };
    }

    default:
      return state;
  }
}
